import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/pt-br'
import Objects from "./Objects";
moment.locale('pt-BR')

export const todayLastTime = () => {
  const date = new Date();
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(59)
  return date;
};


export const todayFirstTime = () => {
  const date = new Date();
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0)
  return date;
};

export const monthDayYear = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('MMMM Do, YYYY') : moment(timestamp).tz(timezone).format('MMMM Do, YYYY')
);

export const monthDayYearAtTime = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('MMMM Do, YYYY [at] hh:mm a') : moment(timestamp).tz(timezone).format('MMMM Do, YYYY [at] hh:mm a')
);

const convert = (timestamp, timezone = 'America/Sao_Paulo', format) => {
  if (Objects.isNullOrUndefined(timestamp)) {
    return '';
  }
  return !timezone ? moment(timestamp).format(format) : moment(timestamp).tz(timezone).format(format)
};

export const dayMonthYear = (timestamp, timezone, separator = '/') => (
    convert(timestamp, timezone, `DD${separator}MM${separator}YYYY`)
);

export const yearMonthDay = (timestamp, timezone) => (
    convert(timestamp, timezone, 'YYYY-MM-DD')
);

export const HourMinute = (timestamp, timezone) => (
    convert(timestamp, timezone, 'HH:mm')
);

export const HourMinuteSeg = (timestamp, timezone) => (
    convert(timestamp, timezone, 'HH:mm:ss')
);

export const dayMonthYearAtTime = (timestamp, timezone) => (
    convert(timestamp, timezone, 'DD/MM/YYYY HH:mm')
);

export const dayMonthYearAtTimeWithSeconds = (timestamp, timezone) => (
    convert(timestamp, timezone, 'DD/MM/YYYY HH:mm:ss')
);

export const timeago = (timestamp, timezone) => (
    !timezone ? moment(timestamp).fromNow() : moment(timestamp).tz(timezone).fromNow()
);

export const temUntil = (timestamp, until) => (
    moment(timestamp).from(until)
);

export const add = (timestamp, amount, range, timezone) => (
    !timezone ? moment(timestamp).add(amount, range).format() : moment(timestamp).tz(timezone).add(amount, range).format()
);

export const getDaysAgo = (daysAgo, timezone) => (
    !timezone ? moment(todayLastTime()).subtract(daysAgo, 'days') : moment(todayLastTime()).subtract(daysAgo, 'days').tz(timezone)
);

export const getMinutesAgo = (minutesAgo, timezone) => (
    !timezone ? moment(new Date()).subtract(minutesAgo, 'minutes') : moment(todayFirstTime()).subtract(minutesAgo, 'minutes').tz(timezone)
);

export const year = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('YYYY') : moment(timestamp).tz(timezone).format('YYYY')
);

export const getLastWeek = () => (
  moment().subtract(7, "days")
);

export const getEndDate = (timestamp) => (
  moment(timestamp).hours(23).minutes(59).seconds(59)
);

export const getStartDate = (timestamp) => (
  moment(timestamp).hours(0).minutes(0).seconds(0)
);



// WEBPACK FOOTER //
// ./src/utils/dates.js